import React from "react";
import { Modal, Button, Icon } from "semantic-ui-react";
import PaymentHistoryDisplay from "./PaymentHistoryDisplay/PaymentHistoryDisplay";
import PropTypes from "prop-types";

const PaymentHistoryModal = ({
  isOpen,
  selectedPatron,
  onClose,
  overrideData = null,
}) => {
  if (!selectedPatron) return null;

  return (
    <Modal open={isOpen} onClose={onClose} size="fullscreen" closeIcon>
      <Modal.Header>
        <Icon name="payment" />
        Payment History - {selectedPatron.name}
        {overrideData && (
          <Icon
            name="edit"
            color="orange"
            title="Contains overridden amounts"
            style={{ marginLeft: "10px" }}
          />
        )}
      </Modal.Header>

      <Modal.Content scrolling>
        <PaymentHistoryDisplay
          patronId={selectedPatron.pid}
          overrideData={overrideData}
          selectedPatron={selectedPatron}
        />
      </Modal.Content>

      <Modal.Actions>
        <Button color="blue" onClick={onClose} icon labelPosition="left">
          <Icon name="close" />
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

PaymentHistoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  selectedPatron: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  overrideData: PropTypes.object,
};

PaymentHistoryModal.defaultProps = {
  selectedPatron: null,
  overrideData: null,
};

export default PaymentHistoryModal;
